<unity-container>
  <h4>Manage Entitlement</h4>

  <!-- <div *ngIf="loading">
  <app-loader></app-loader>
</div> -->
  <div>
    <entitlement-breadcrumbs
      [items]="breadcrumbItems"
    ></entitlement-breadcrumbs>
    <div class="em-c-toolbar em-c-toolbar--order em-u-margin-bottom">
      <div class="em-c-toolbar__item">
        <div class="em-c-dropdown-check em-js-dropdown-check">
          <h5 class="entitlement-header">Service:</h5>
          <ul class="em-c-tags entitlement-tag">
            <li class="em-c-tags__item em-js-tags-item">
              <a
                [routerLink]="['/entitlement-service', serviceId]"
                class="em-c-tags__link em-js-tags-trigger"
              >
                <span class="em-c-tags__text"> {{ serviceName }} </span>
              </a>
            </li>
          </ul>
        </div>
        <!-- End em-c-dropdown-check -->
      </div>
      <!-- end em-c-toolbar__item -->
    </div>
    <div class="em-c-toolbar em-c-toolbar--order em-u-margin-bottom">
      <div class="em-c-toolbar__item">
        <div class="em-c-dropdown-check em-js-dropdown-check">
          <h5 class="entitlement-header">Client:</h5>
          <ul class="em-c-tags entitlement-tag">
            <li class="em-c-tags__item em-js-tags-item">
              <a
                [routerLink]="['/entitlement-client', clientId]"
                class="em-c-tags__link em-js-tags-trigger"
              >
                <span class="em-c-tags__text"> {{ clientName }} </span>
              </a>
            </li>
          </ul>
        </div>
        <!-- End em-c-dropdown-check -->
      </div>
      <!-- end em-c-toolbar__item -->
    </div>
    <div class="em-c-toolbar em-c-toolbar--order em-u-margin-bottom">
      <div class="em-c-toolbar__item">
        <div class="em-c-dropdown-check em-js-dropdown-check">
          <div>Entitlement list</div>
        </div>
        <!-- End em-c-dropdown-check -->
      </div>
      <!-- end em-c-toolbar__item -->
      <div class="em-c-toolbar__item em-is-aligned-right">
        <div class="em-c-btn-group">
          <div class="em-c-field__body top-searchbox em-c-field em-is-readonly">
            <input
              class="em-c-input em-js-input"
              placeholder="Search"
              [(ngModel)]="searchString"
            />
            <svg
              class="em-c-icon em-c-icon--medium em-c-field__icon em-u-clickable"
              (click)="clearSearch()"
            >
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#circle-x"
              ></use>
            </svg>
          </div>
          @if (getMode("any") === "READ") {
            <button
              class="em-c-btn em-c-btn--primary em-c-btn--medium"
              (click)="addNewRecord()"
            >
              <span class="em-c-btn__text">Add</span>
            </button>
          }
          @if (getMode("any") === "DISABLE") {
            <button
              class="em-c-btn em-c-btn--primary em-c-btn--medium em-c-btn--disabled"
            >
              <span class="em-c-btn__text">Add</span>
            </button>
          }
          <!-- end em-c-btn -->
        </div>
        <!-- end em-c-btn-group -->
      </div>
      <!-- end em-c-toolbar__item -->
    </div>
    <div class="entitlement-list-table">
      <unity-table [ngStyle]="{ paddingBottom: '220px' }">
        <thead unity-table-head>
          <tr unity-table-head-row>
            @for (key of entitlementKey; track key) {
              <th scope="col" unity-table-head-cell>
                {{ key }}
              </th>
              <th scope="col" unity-table-head-cell>Description</th>
            }
            <th
              scope="col"
              unity-table-head-cell
              class="em-u-text-align-center em-u-width-10"
            >
              Action
            </th>
          </tr>
        </thead>
        @for (
          entitlement of entitlementServices;
          track entitlement;
          let entitlementIndex = $index
        ) {
          <tbody
            unity-table-body
            [ngStyle]="{ paddingBottom: '220px !important' }"
          >
            @for (
              group of entitlement.entitlements
                | entitlementValueFilter: searchString;
              track group
            ) {
              <tr unity-table-row>
                @for (key of entitlementKey; track key) {
                  <td unity-table-cell>
                    @if (getMode(group["group"]["groupId"]) === "EDIT") {
                      <search-key-input
                        [(selectedValue)]="searchKey"
                        [(clickedValue)]="clickedKey"
                        [initialValue]="group['data'][key]"
                        [minQueryLength]="3"
                        (selectedValueChange)="
                          onEntitlementSearchKeyChange(
                            group['group']['groupId'],
                            key,
                            group['data'][key]
                          )
                        "
                        (clickedValueChange)="
                          onEntitlementSearchKeyClick(
                            group['group']['groupId'],
                            key,
                            group['data'][key]
                          )
                        "
                        [serviceId]="this.serviceId"
                        [key]="key"
                      ></search-key-input>
                    }
                    @if (getMode(group["group"]["groupId"]) !== "EDIT") {
                      <div>
                        {{ group["data"][key] }}
                        @if (showDeletedBadge(group["group"]["groupId"])) {
                          <span class="em-c-badge em-c-badge--caution"
                            >Deleted</span
                          >
                        }
                      </div>
                    }
                  </td>
                  <td unity-table-cell>
                    @if (getMode(group["group"]["groupId"]) !== "EDIT") {
                      <span>{{
                        (group["description"] && group["description"][key]) ||
                          "No Description"
                      }}</span>
                    }
                    @if (getMode(group["group"]["groupId"]) === "EDIT") {
                      <span>{{
                        currentEntitlementData.description
                          ? currentEntitlementData.description[key]
                          : ""
                      }}</span>
                    }
                  </td>
                }
                <td
                  unity-table-cell
                  class="em-u-text-align-center em-u-width-10"
                >
                  <!-- Read mode -->
                  @if (getMode(group["group"]["groupId"]) === "READ") {
                    <div class="em-c-btn-group">
                      <button
                        class="em-c-btn"
                        (click)="
                          handleEdit(group['group']['groupId'], $event, group)
                        "
                      >
                        <div class="em-c-btn__inner">
                          <svg
                            class="em-c-icon em-c-icon--small em-c-btn__icon"
                            data-em-icon-path="assets/unity-1.6.0/images/em-icons.svg"
                          >
                            <use
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="assets/unity-1.6.0/images/em-icons.svg#settings"
                            ></use>
                          </svg>
                          <span class="em-c-btn__text">EDIT</span>
                        </div>
                      </button>
                      <button
                        class="em-c-btn em-c-btn--secondary"
                        (click)="openConfirmPopUp(group['group']['groupId'])"
                      >
                        DELETE
                      </button>
                    </div>
                  }
                  <!-- Disable mode -->
                  @if (getMode(group["group"]["groupId"]) === "DISABLE") {
                    <div class="em-c-btn-group">
                      <button class="em-c-btn em-c-btn--disabled">
                        <div class="em-c-btn__inner">
                          <svg
                            class="em-c-icon em-c-icon--small em-c-btn__icon"
                            data-em-icon-path="assets/unity-1.6.0/images/em-icons.svg"
                          >
                            <use
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="assets/unity-1.6.0/images/em-icons.svg#settings"
                            ></use>
                          </svg>
                          <span class="em-c-btn__text">EDIT</span>
                        </div>
                      </button>
                      <button
                        class="em-c-btn em-c-btn--secondary em-c-btn--disabled"
                      >
                        DELETE
                      </button>
                    </div>
                  }
                  <!-- Edit mode -->
                  @if (getMode(group["group"]["groupId"]) === "EDIT") {
                    <div class="em-c-btn-group">
                      <button
                        class="em-c-btn em-c-btn--primary"
                        (click)="handleSave()"
                      >
                        SAVE
                      </button>
                      <button
                        class="em-c-btn em-c-btn--secondary"
                        (click)="handleCancel()"
                      >
                        CANCEL
                      </button>
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        }
      </unity-table>
    </div>
  </div>
</unity-container>

<!-- Confirm Delete -->
@if (showConfirmPopup) {
  <div class="em-c-modal em-c-modal--alert em-js-modal-only" id="">
    <div class="em-c-modal__window em-js-modal-window">
      <div class="em-c-modal__header">
        <h3 class="em-c-modal__title">Confirm Delete Entitlement</h3>
        <button
          class="em-c-btn em-c-btn--bare em-c-modal__close-btn em-js-modal-close-trigger"
          (click)="closePopUp(confirmDeleteGroupId)"
        >
          <div class="em-c-btn__inner">
            <svg
              class="em-c-icon em-c-icon--small em-c-btn__icon"
              data-em-icon-path="assets/unity-1.6.0/images/em-icons.svg"
            >
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="assets/unity-1.6.0/images/em-icons.svg#x-filled"
              ></use>
            </svg>
          </div>
        </button>
        <!-- end em-c-btn -->
      </div>
      <!-- end em-c-modal__header -->
      <div class="em-c-modal__body em-c-text-passage em-c-text-passage--small">
        Are you sure to remove this entitlement?
        <div class="em-c-btn-group em-c-modal--alert em-js-modal-only">
          <button
            class="em-c-btn em-c-btn--primary em-js-modal-confirm-trigger"
            (click)="handleDelete(confirmDeleteGroupId)"
          >
            <span class="em-c-btn__text">OK</span>
          </button>
          <!-- end em-c-btn -->
          <button
            class="em-c-btn em-c-btn--secondary em-js-modal-cancel-trigger"
            (click)="closePopUp(confirmDeleteGroupId)"
          >
            <span class="em-c-btn__text">Cancel</span>
          </button>
          <!-- end em-c-btn -->
        </div>
        <!-- end em-c-btn-group -->
      </div>
      <!-- end em-c-modal__body -->
    </div>
    <!-- end em-c-modal__window -->
  </div>
}
<!-- end em-c-modal -->
<!-- End : Confirm Delete -->
